<script lang="ts">
    import ScoringSurveysPage from '@Evaluation/AlternativesSurveys/Pages/ScoringSurveysPage'
    export default ScoringSurveysPage
</script>

<template>
    <div>
        <ScoringSurveyAccessLinks :viewModel="scoringSurveyAccessLinks"
                                  @show-email-sender="handleShowEmailSender"
                                  @download-links="handleDownloadAccessLinks" />

        <ScoringSurveyEmailSender :viewModel="scoringSurveyEmailSender"
                                  @send-email="handleSendEmailCommand" />

        <SurveyOpenerDialog :propOpened="surveyOpenerSurveyId != null" :propSurveyId="surveyOpenerSurveyId"
                            @start-survey="handleStartSurveyCommand"
                            @show-access-links="showAccessLinks"
                            @close-dialog="surveyOpenerSurveyId = null" />

        <SurveyCloserDialog :propOpened="surveyCloserSurveyId != null" :propSurveyId="surveyCloserSurveyId"
                            @stop-survey="handleStopSurveyCommand"
                            @close-dialog="surveyCloserSurveyId = null" />

        <SurveyAlternativesManagerDialog :viewModel="surveyAlternativesManagerDialog"
                                         @preview-description="handleLoadAlternativeDescription"
                                         @load-alternatives="handleLoadAlternativesByList"
                                         @save-survey="handleUpdateSurveyAlternativesCommand" />

        <SurveyCriteriaManagerDialog :viewModel="surveyCriteriaManagerDialog"
                                     @update-survey-criteria="handleUpdateSurveyCriteriaCommand" />

        <SubSurveysManagerDialog :viewModel="subSurveysManagerDialog"
                                 @include-sub-survey="handleIncludeSubSurveyCommand"
                                 @exclude-sub-survey="handleExcludeSubSurveyCommand"
                                 @change-vote-strength="handleChangeSubSurveyVoteStrengthCommand" />


        <SurveyEditorDialog :viewModel="surveyEditorDialog"
                            @delete-survey="handleDeleteSurveyCommand"
                            @create-survey="handleCreateSurveyCommand"
                            @update-survey="handleUpdateSurveyCommand" />

        <ScoresExporter :viewModel="scoresExporter"
                        @show-attribute-creator="showAttributeCreator"
                        @load-preview="loadScoresExporterPreview"
                        @reset-preview="resetScoresExporterPreview"
                        @export-scores="handleExportSurveyScoresToAttributesCommand"
                        @close-dialog="closeScoresExporter" />

        <AttributeEditorDialog :viewModel="attributeEditorDialog"
                               @numeric-attribute-created="numericAttributeCreated" />


        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <h3 v-if="!rm"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>

            <div v-if="rm">
                <a class="btn btn-outline-secondary float-right" href="https://www.transparentchoice.com/user-guide/pick-a-winner" title="User guide: Pick a winner" target="_blank">
                    <i class="fa fa-info" aria-hidden="true"></i>
                </a>
                <h3>Goal: {{rm.GoalName}}</h3><br />
                <GoalNavigation :WorkspaceId="workspaceId" :ProjectId="projectId" :EvalModelId="evalModelId" ActivePage="scoring-surveys" :ScoringEnabled="true" />

                <button role="button" class="btn btn-success" @click="showSurveyCreator">
                    Create opinion panel
                </button>

                <button role="button" class="btn btn-outline-secondary" @click="handleExportAllScoringVotesToXlsCommand">
                    Export votes
                </button>
                <br />
                <br />

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-for="s in surveysView" :key="s.Id">
                        <div class="card mt-2">
                            <div class="card-body">
                                <h5 class="card-title">
                                    <i class="fa fa-lock text-danger" title="Survey is closed" v-if="s.SurveyStarted === false"></i>
                                    <i class="fa fa-unlock-alt text-success" title="Survey is open" v-if="s.SurveyStarted === true"></i>
                                    <span>{{s.Name}}</span>
                                </h5>
                                <div class="row">
                                    <div class="col text-nowrap">
                                        <a class="text-primary" v-sanitizedHref="url_ScoringPanelistsPage(s.Id)">Panelists: {{s.RespondentsCount}}</a>
                                    </div>
                                    <div class="col text-nowrap">
                                        <a class="text-primary" @click="showSubSurveysManager(s.Id)">Combined panels:  {{s.SubSurveysCount}}</a>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col text-nowrap">
                                        <a class="text-primary" @click="showSurveyCriteriaManager(s.Id)">Criteria: {{s.CriteriaCount}}/{{rm.CriteriaCount}}</a>
                                    </div>
                                    <div class="col text-nowrap">
                                        <span>Questions: {{s.QuestionsCount}}</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col text-nowrap">
                                        <a class="text-primary" @click="showSurveyAlternativesManager(s.Id)">
                                            {{rm.AlternativesLabel}}: {{s.AlternativesCount}}/{{rm.AlternativesCount}}
                                        </a>
                                    </div>
                                </div>
                                <br>

                                <a v-if="s.HasQuestions === true" v-sanitizedHref="url_ScoringMeetingManagerPage(s.Id)" class="btn btn-sm btn-outline-secondary">Review</a>
                                <button v-if="s.HasQuestions === false" disabled class="btn btn-sm btn-outline-secondary">Review</button>

                                <div class="dropdown d-inline-block">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="showSurveyEditor(s)">Edit</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showSurveyOpener(s.Id)" v-if="s.SurveyStarted === false">Open survey</a>
                                        <a class="dropdown-item" @click="showSurveyCloser(s.Id)" v-if="s.SurveyStarted === true">Close survey</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showScoresExporter(s.Id)">Save scores</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="confirmSurveyDelete(s)">Delete</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
